export default __webpack_public_path__ + "static/media/padel-nox.aecafc44.png";